import { NO_STREAMS, LOADING, SUCCESS_STREAMS, SELECT_STREAM, UPDATE_SELECTED_STREAM, SUCCESS_FILTERS, SUCCESS_DATA, SUCCESS_COMPARISON_DATA, UPDATE_DATES, UPDATE_DATE_RANGE } from './ReportActions';

const INITIAL_STATE = {  
  noStreams: false,
  isLoading: false,
  loaded: false,
  settings: {
    dashboards: [],
  },
  streams: [],
  filters: {
    dashboards: [],
  },
  stats: {},
  trends: {},
  comparisons: {},
  selectedStream: {}
};

const ReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NO_STREAMS: {
      return { ...state, isLoading: false, noStreams: true, loaded: true, selectedStream:{}, streams: [], issue: '' };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS_STREAMS: {
      return { ...state, isLoading: false, loaded: true, streams: action.streams };
    }
    case SELECT_STREAM: {
      return { ...state, isLoading: false, noStreams: false, selectedStream: action.selected, viewId: action.viewId, stats: {}, trends: {}, comparisons: {} };
    }
    case UPDATE_SELECTED_STREAM: {
      return { ...state, selectedStream: action.selected };
    }
    case SUCCESS_FILTERS: {
      return { ...state, filters: action.filters };
    }
    case SUCCESS_DATA: {
      const hasNewStats = action.data.stats && Object.keys(action.data.stats).length > 0;
      const hasNewTrends = action.data.trends && Object.keys(action.data.trends).length > 0;
      return {
        ...state,
        isLoading: false,
        stats: hasNewStats ? action.data.stats : state.stats,
        trends: hasNewTrends ? action.data.trends : state.trends
      };
    }
    case SUCCESS_COMPARISON_DATA: {
      const hasNewComparisons = action.data.comparisons && Object.keys(action.data.comparisons).length > 0;
      return {
        ...state,
        isLoading: false,
        comparisons: hasNewComparisons ? action.data.comparisons : state.comparisons
      };
    }
    case UPDATE_DATE_RANGE: {
      return { ...state, dateRange: action.data };
    }
    case UPDATE_DATES: {
      return { ...state, dates: action.data };
    }
    default:
      return state;
  }
};

export default ReportReducer;
